const riot = require('riot');

riot.tag2('cell-link', '<a class="text-blue_70 hover-only-text-blue_70" href="{opts.schema.getLink(opts.item)}">{opts.getCellText(opts.item, opts.schema)}</a>', '', '', function(opts) {
});